import {Status} from 'platform/components';
import {VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

/**
 * Replaces both MOT sections on the tall and wide tiles when the overview reports no expired and
 * no expiring car, and fills the remaining card height so the status stays optically centred.
 */
export function VehicleMotAllGood(props: TestIdProps) {
  return (
    <VStack grow={1} justify="center">
      <Status
        severity="success"
        icon="action/check_circle"
        headline={i18n.t('page.homepage.vehicleWarehouse.labels.allMotValid')}
        subheadline={i18n.t('page.homepage.vehicleWarehouse.labels.allMotValidDescription')}
        data-testid={suffixTestId('motAllGood', props)}
      />
    </VStack>
  );
}
